<template>
  <div class="addModel myinput">
    <div class="addemBtns">
      编辑电源控制器
    </div>
    <div>
      <div class="emid">
        <div>
          <span>名称</span>
          <el-input v-model="switchName" maxlength="100"></el-input>
        </div>
        <div>
          <span>编号</span>
          <el-input v-model="serialNumber" maxlength="100"></el-input>
        </div>
        <div>
          <span>MQTT主题</span>
          <el-input v-model="mqttApi" maxlength="100"></el-input>
        </div>
        <div>
          <span>EUI</span>
          <el-input v-model="eui" maxlength="100"> </el-input>
        </div>
        <div>
          <span>额定功率</span>
          <el-input v-model="power" maxlength="100"></el-input>
        </div>
        <div>
          <span>额定电压</span>
          <el-input v-model="electric" maxlength="100"></el-input>
        </div>
      </div>
    </div>
    <div class="detailed">
      <div class="element-list jb-bg btn" @click="submit">确认</div>
      <div class="element-list jb-bg btn" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pInfo"],
  data() {
    return {
      ckVal: 1,
      depotId:'', //仓库id
      //电源控制器
      id:'', //当前修改电源控制器id
      switchName: "", // 名称
      serialNumber: "", //编号
      mqttApi: "", //mqtt主题
      eui: "", //电源控制器eui
      electric: "", //额定电压
      power: "", //额定功率
    };
  },
  created() {
    this.depotId = sessionStorage.getItem('depotId');
    this.switchName = this.pInfo.switchName
    this.serialNumber = this.pInfo.serialNumber;
    this.mqttApi = this.pInfo.mqttApi;
    this.eui = this.pInfo.eui;
    this.electric = this.pInfo.electric;
    this.power = this.pInfo.power;
    this.id = this.pInfo.id
  },
  methods: {
    submit() {
      let data2 = {
        switchName:this.switchName,
        serialNumber:this.serialNumber,
        depotId:this.depotId,
        mqttApi:this.mqttApi,
        eui:this.eui,
        electric:parseFloat(this.electric),
        power:parseFloat(this.power),
        id:this.id
      };
      let data = JSON.parse(JSON.stringify(data2));
      this.$emit("submit", data);
      this.clearInfo()
    },
    cancel() {
      this.$emit("cancel");
      this.clearInfo()
    },
    clearInfo() {
      this.switchName = '';
      this.serialNumber = '';
      this.mqttApi = '';
      this.eui = '';
      this.electric = '';
      this.power = '';
      this.id = ''
    },
  },
};
</script>

<style lang='less' scoped>
.select_option{
  background: #092e5f !important;
  color: #ffffff !important;
}
.addModel {
  height: 450px;
  color: #74c8fe;
  margin: 0 30px;
  .addemBtns {
    margin: 30px 10px;
    font-size:16px;

  }
  .addem {
    display: flex;
    height: 50px;
    line-height: 50px;
    margin: 0 5px;
    .el-input {
      width: 260px;
      margin: 0px 15px;
    }
    span {
      width: 85px;
      text-align: center;
      text-align-last: justify;
    }
    .el-select{
    margin: 0 15px;
  }
  }
  .emid {
    height: 50px;
    line-height: 50px;
    .el-input {
      width: 260px;
      margin: 0px 15px;
    }
    span {
      display: -moz-inline-box;
      display: inline-block;
      width: 85px;
      text-align: center;
      text-align-last:justify
    }
    margin-bottom: 20px;
  }

  .detailed {
    margin: 0 30px 20px;
    clear: both;
    display: flex;
    position: absolute;
    bottom: 0px;
    .btn {
      width: 150px;
      margin-right: 10px;
      cursor: pointer;
    }

    .element-list {
      border: 2px solid#0090F0;
      border-radius: 6px;
      height: 30px;
      line-height: 30px;
      margin: 10px 5px;
      text-align: center;
    }
    .jb-bg {
      background-image: linear-gradient(#0479b4, #02407e);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/editPower.vue